import { render, staticRenderFns } from "./PluginDetails.vue?vue&type=template&id=645e5b53&scoped=true"
import script from "./PluginDetails.vue?vue&type=script&lang=js"
export * from "./PluginDetails.vue?vue&type=script&lang=js"
import style0 from "./PluginDetails.vue?vue&type=style&index=0&id=645e5b53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645e5b53",
  null
  
)

export default component.exports